module.exports = __webpack_public_path__ + "img/1.de82691f.jpg";